var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"influencer-audience-edit","toptitle":"Zielgruppe bearbeiten","title":_vm.influencerAudience.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('influencer-audience-form',{attrs:{"influencerAudience":_vm.influencerAudience,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }